export const GET_TOTAL_STATS = 'CIVIL_REGISTRY/get_total_stats';
export const GET_GRAPH_STATS = 'CIVIL_REGISTRY/get_graph_stats';

export const LEGENDS = [
  { name: 'BIRTH CERTIFICATE', color: '#5272AA', value: 0 },
  { name: 'DEATH CERTIFICATE', color: '#A3B3F9', value: 0 },
  { name: 'MARRIAGE CERTIFICATE', color: '#8EEED7', value: 0 },
];
